import { getWindowSize, missingWidget } from '../utils/helpers';
import { updateLinksAttributes } from '../utils/handleAttributes';
const breakpointMobile = 600;

function customCards(itemId, itemOpts, wrapContainer, cardsQuantity) {
  const widgetName = itemId;
  const $widget = $(`#${widgetName}`);
  const widgetOpts = itemOpts;

  if (!widgetOpts) {
    $(`.${wrapContainer}`).remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: getWindowSize(breakpointMobile) ? [''] : ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: cardsQuantity,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainer}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL, PurchaseURL } = widgetData[x];
      const $cardItem = $(this);

      const learnMoreBtn = URL
        ? `<a href="${URL}" class="button" ${updateLinksAttributes(URL, Title + ' - Learn More')}>More</a>`
        : '';

      const buyBtn = PurchaseURL
        ? `<a href="${PurchaseURL}" class="button" ${updateLinksAttributes(PurchaseURL, Title + ' - Buy Now')}>Buy now</a>`
        : '';

      $cardItem.append(`
          <div class="card-content">
            <h3 class="widget-title">${Title}</h3>
          </div>
          <div class="hover-content">
            ${learnMoreBtn}
            ${buyBtn}
          </div>

          
          `);
      if (!getWindowSize(breakpointMobile)) {
        updateLinks($cardItem, URL, PurchaseURL, Title);
      }
      validateContent($cardItem, URL, PurchaseURL);
    });
  }
}

function validateContent($item, moreLink, buyLink) {
  $item.removeAttr('target').removeClass('void-link');
  if ((moreLink == null || moreLink == undefined) && (buyLink == null || buyLink == undefined)) {
    $item.addClass('void-link');
  }
}

function updateLinks($item, moreLink, buyLink, itemTitle) {
  if (moreLink != null || moreLink != undefined) {
    updateLinksAttributes(moreLink, itemTitle, $item);
  }

  if (buyLink != null || buyLink != undefined) {
    $item.attr('href', buyLink);
    updateLinksAttributes(buyLink, itemTitle, $item);
  }

  if ((moreLink == null || moreLink == undefined) && (buyLink == null || buyLink == undefined)) {
    $item.removeAttr('href');
    updateLinksAttributes(buyLink, itemTitle, $item);
  }
}

export default function updateCards(itemId, itemOpts, cardsQuantity) {
  const wrapContainer = `${itemId}-wrap-container`;
  const mediaQuery = globalThis.matchMedia(`(max-width: ${breakpointMobile}px)`);

  function triggerFeature() {
    $(`.${wrapContainer} #${itemId}`).empty();
    customCards(itemId, itemOpts, wrapContainer, cardsQuantity);
  }

  triggerFeature();

  mediaQuery.addEventListener('change', triggerFeature);
}
